import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "col-md-6 offset-md-3" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Email:", -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.setProfile == '' || _ctx.isLoading == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_spinner)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.setProfile.name), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.setProfile.tagLine), 1),
                _hoisted_6
              ]),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setProfile.bio, (bio) => {
                  return (_openBlock(), _createElementBlock("span", { key: bio }, [
                    _createTextVNode(_toDisplayString(bio) + " ", 1),
                    _hoisted_7
                  ]))
                }), 128)),
                _hoisted_8
              ]),
              _hoisted_9,
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setProfile.email, (email) => {
                  return (_openBlock(), _createElementBlock("span", { key: email }, [
                    _createElementVNode("a", {
                      href: `mailto:${email}`
                    }, _toDisplayString(email), 9, _hoisted_10),
                    _hoisted_11
                  ]))
                }), 128)),
                _hoisted_12
              ])
            ])
          ])
        ])),
    _hoisted_13
  ], 64))
}